import { isPlatformServer } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { map, Observable } from "rxjs";
import { CacheObservable } from "../common/cache-observable";
import CacheExpirations from "../constants/cache-expirations";
import { LanguageModel } from "../models/api/language.model";
import { ApiLanguageService } from "./api/api-language.service";
import { LanguageService } from "./language.service";

@Injectable({
  providedIn: 'root'
})
export class LanguageCacheService {
  private itemsCache = new CacheObservable<LanguageModel[]>(CacheExpirations.oneHour);

  constructor(private readonly apiLanguageService: ApiLanguageService,
    private readonly languageService: LanguageService,
    @Inject(PLATFORM_ID) private readonly platformId: string) {
  }

  public getAll(): Observable<LanguageModel[]> {
    const key = `language-all`;

    return this.itemsCache.getCachedItems(isPlatformServer(this.platformId), key, () => this.apiLanguageService.getAll());
  }

  public getCurrentLanguage(): Observable<LanguageModel | null> {
    return this.getAll()
      .pipe(map(languages => {
        return languages.find(language => language.key === this.languageService.currentLanguageCode) ?? null;
      }));
  }
}
